var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import styled from 'styled-components';
import { dataLoader } from 'utils/helpers';
import useMemberSelect from './useMemberSelect';
var MemberSelect = function (_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange, allowClear = _a.allowClear, _b = _a.placeholder, placeholder = _b === void 0 ? 'Member' : _b, memberId = _a.value, variables = _a.variables, restProps = __rest(_a, ["defaultValue", "onChange", "allowClear", "placeholder", "value", "variables"]);
    var _c = useMemberSelect({
        memberId: memberId,
        variables: variables
    }), functions = _c.functions, data = _c.data;
    var loading = data.loading, memberOptions = data.memberOptions;
    var debouncedSearch = functions.debouncedSearch, onPopupScroll = functions.onPopupScroll;
    var options = memberOptions.map(function (option) { return ({
        id: option.id,
        sharedId: option.sharedId,
        value: option.id,
        label: (_jsxs(_Fragment, { children: [option.name, _jsx(MemberInfo, { children: option.info })] }))
    }); });
    return (_jsx(Select, __assign({ value: memberId || defaultValue, onChange: onChange, showSearch: { onSearch: debouncedSearch, filterOption: false }, popupMatchSelectWidth: false, notFoundContent: dataLoader(loading), onPopupScroll: onPopupScroll, placeholder: placeholder, allowClear: allowClear, "data-test": "memberFilter", loading: loading, options: options }, restProps)));
};
var MemberInfo = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #4f8dcc;\n"], ["\n  color: #4f8dcc;\n"])));
export default MemberSelect;
var templateObject_1;
